import * as React from "react";

import { Button } from "../../ui/button";
import { cn } from "../../../lib/utils";

type DataTableFilterChipsProps = {
  children: React.ReactNode;
  showClearAction?: boolean;
  clearLabel?: string;
  onClear?: () => void;
  className?: string;
};

export function DataTableFilterChips({
  children,
  showClearAction = false,
  clearLabel = "Clear filters",
  onClear,
  className,
}: DataTableFilterChipsProps) {
  return (
    <div className={cn("flex flex-wrap items-center gap-1.5", className)}>
      {children}
      {showClearAction ? (
        <Button
          type='button'
          variant='text'
          className='h-6 px-1.5 py-0 text-xs font-medium text-muted-foreground hover:text-destructive focus-visible:text-destructive'
          onClick={onClear}
        >
          {clearLabel}
        </Button>
      ) : null}
    </div>
  );
}
